/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candid_Super_Whale_StopInputs */

const fr_candid_super_whale_stop = /** @type {(inputs: Candid_Super_Whale_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom d'utilisateur doit faire au moins 3 caractères`)
};

/**

* @param {Candid_Super_Whale_StopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const candid_super_whale_stop = /** @type {((inputs?: Candid_Super_Whale_StopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candid_Super_Whale_StopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_candid_super_whale_stop(inputs)
});